"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBadgerOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var BBadgerOracleFactory = /** @class */ (function (_super) {
    __extends(BBadgerOracleFactory, _super);
    function BBadgerOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    BBadgerOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BBadgerOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BBadgerOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BBadgerOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BBadgerOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return BBadgerOracleFactory;
}(contracts_1.ContractFactory));
exports.BBadgerOracleFactory = BBadgerOracleFactory;
var _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "bBadger",
        outputs: [
            {
                internalType: "contract IBadgerSett",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "badger",
        outputs: [
            {
                internalType: "contract BaseERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "badgerEthChainlinkOracle",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
